"use client";

import { useAtomValue, useSetAtom } from "jotai";
import { startTransition, useCallback } from "react";
import styled from "styled-components";
import { isAdminNavbarOpened, isMobileAtom } from "../../store/layoutStore";
import { sizes } from "../../styles/globalsStyles";
import { userAtom } from "../../store/userAtom";
import { APP_VERSION } from "../../utils/version";
import Image from "next/image";

const NavbarImage = () => {
  const user = useAtomValue(userAtom);
  const isMobile = useAtomValue(isMobileAtom);

  const setAdminNavbar = useSetAtom(isAdminNavbarOpened);

  const handleClickOnPicture = useCallback(() => {
    if (!user?.isAdmin) return;

    startTransition(() => {
      setAdminNavbar((state) => !state);
    });
  }, [setAdminNavbar, user?.isAdmin]);

  return (
    <ImageWrapper>
      <Image
        alt="rina styling"
        src="/assets/buisnessLogo.png"
        width={!isMobile ? sizes.navbarHeight : sizes.navbarHeight}
        height={sizes.navbarHeight}
        sizes="100%"
        style={{ cursor: user?.isAdmin ? "pointer" : undefined }}
        onClick={handleClickOnPicture}
      />
      <VersionTag>v{APP_VERSION}</VersionTag>
    </ImageWrapper>
  );
};

export default NavbarImage;

const ImageWrapper = styled.div`
  position: relative;
`;

const VersionTag = styled.span`
  position: absolute;
  bottom: 5px;
  left: 5px;
  font-size: 9px;
  line-height: 1;
  color: #aaa;
  pointer-events: none;
  user-select: none;
`;
